/**
 * Constants for artwork processing loading states
 */
export const ARTWORK_PROCESSING = {
  /**
   * Estimated duration for artwork processing (in milliseconds)
   * Includes background removal, enhancement, vibrancy boost, and edge refinement
   */
  ESTIMATED_DURATION: 55_000 // 55 seconds
} as const;
